/* eslint-disable react-hooks/exhaustive-deps */
import { CSSProperties, MouseEvent, useEffect, useRef } from "react"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"

/* Protopia Ecosystem component */
export interface IRotateHandlerProps {
   style: CSSProperties
   onDragStart: (evt: MouseEvent) => void
   onDrag: (height: number) => void
   onDragEnd: (height: number) => void
}
const HeightHandler = (props: IRotateHandlerProps): JSX.Element => {
    const startDragPos = useSyncState<any>({})
    const ref = useRef(null)
    const onDragStart = (evt: MouseEvent) => { 
        evt.dataTransfer.setDragImage(evt.target, window.outerWidth, window.outerHeight)
        const target = evt.target as HTMLDivElement
        const parent = target.parentElement
        const top = +parseInt(parent!.style.top)
        startDragPos.set({
            top: evt.clientY - top,
            left: evt.clientX
        })
        evt.stopPropagation() 
        //evt.preventDefault()
    }
    const onDrag = (evt: MouseEvent) => { 
        const target = evt.target as HTMLDivElement   
        const top = (evt.clientY - startDragPos.get().top  + 13) 
        target.style.top  = top + "px"
        // target.style.left = (evt.clientX - startDragPos.get().left) + "px"
        evt.stopPropagation() 
        evt.preventDefault()
        props.onDrag(top)
    }
    const onDragEnd = (evt: MouseEvent) => { 
        const target = evt.target as HTMLDivElement   
        const top = (evt.clientY - startDragPos.get().top  + 13) 
        target.style.top  = top + "px"
        evt.stopPropagation() 
        evt.preventDefault()
        props.onDragEnd(top)
    }
    useEffect(() => {
        const shifter = (ref.current! as any)  
        shifter.addEventListener("dragstart", onDragStart) 
        shifter.addEventListener("drag", onDrag) 
        shifter.addEventListener("dragend", onDragEnd) 
        return () => {
            shifter.removeEventListener("dragstart", onDragStart) 
            shifter.removeEventListener("drag", onDrag) 
            shifter.removeEventListener("dragend", onDragEnd) 
        }
    }, [])
    
    return <div 
        className='scale-handler' style={props.style}
        draggable
        ref={ref}
    >
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            x="0px" 
            y="0px"
            width="30px"
            height="30px"
            viewBox="0 0 576 596.4" 
            xmlSpace="preserve"
        > 
            <g id="Layer_3">
                <circle className="st0" cx="288" cy="294.7" r="32.5"/>
                <path d="M288,331c-19.9,0-36-16.1-36-36s16.1-36,36-36s36,16.1,36,36S307.9,331,288,331z M288,265.7c-16.2,0-29.3,13.2-29.3,29.3
                    s13.2,29.3,29.3,29.3s29.3-13.2,29.3-29.3S304.2,265.7,288,265.7z"/>
            </g>
            <g id="Layer_2">
                <polygon className="st1" points="227.3,477.2 348.7,479.8 286.7,539.2 	"/>
                <polygon className="st1"  points="348.7,123.3 227.3,120.6 289.3,61.2 	"/>
                <rect className="st1"  x="266.5" y="111" width="43" height="71"/>
                <rect className="st1"  x="266.5" y="420" width="43" height="71"/>
            </g>
        </svg>
    </div>
}
export default HeightHandler